import { ListenerEffectAPI } from '@reduxjs/toolkit'
import Router from 'next/router'

import { addProduct } from '../features/checkout/checkoutSlice'
import { closeOverlay } from '../features/overlay/overlaySlice'
import { AppDispatch, RootState } from '../store'
import logger from '../utils/logger'
import { throwIfAborted } from './throwIfAborted'

const effect = async (_: unknown, listenerAPI: ListenerEffectAPI<RootState, AppDispatch>) => {
  const originalPath = listenerAPI.getOriginalState().overlay.originalPath
  listenerAPI.cancelActiveListeners()
  if (listenerAPI.getOriginalState().overlay.view.type !== 'PRODUCT') {
    return
  }
  await listenerAPI.delay(1000)
  try {
    throwIfAborted(listenerAPI.signal)
    listenerAPI.dispatch(closeOverlay)
    if (originalPath) {
      Router.push(originalPath, undefined, { shallow: true })
    } else {
      Router.back()
    }
  } catch (err) {
    logger.debug({ label: 'productModalCloseMiddleware', msg: 'canceled', err })
  }
}

const productModalCloseMiddleware = {
  effect,
  matcher: addProduct.match,
} as const

export default productModalCloseMiddleware
